export default __webpack_public_path__ + "4ed78cd5d64af4efc3c714622b9372d4.ttf";